import { render, staticRenderFns } from "./MainSidebarDisabledOverlay.vue?vue&type=template&id=2195a72d&scoped=true"
import script from "./MainSidebarDisabledOverlay.vue?vue&type=script&lang=js"
export * from "./MainSidebarDisabledOverlay.vue?vue&type=script&lang=js"
import style0 from "./MainSidebarDisabledOverlay.vue?vue&type=style&index=0&id=2195a72d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2195a72d",
  null
  
)

export default component.exports